import React, { useRef, Fragment } from 'react';
import classNames from 'classnames';
import Modal from '../../Modal';
import { OpenModalButton, ModalPanel, CloseModalButton } from '../../Modal';
import ToggleMore from '../toggle-more';
import List from '../components/list';

const EServices = (props) => {
  const expandableList = useRef();
  const matomoTrackingClass = 'e-tjänster';

  const { EServices, Translations } = props;
  if (!EServices) return null;

  const setFocus = (id) => {
    const activeBtn = document.querySelector(`[data-buttonid='open${id}']`);
    if (activeBtn) {
      const content = activeBtn?.nextSibling?.getElementsByClassName(
        'e-services__modal-panel__content'
      );
      if (content) {
        content[0].focus();
      }
    }
  };

  return (
    <div ref={expandableList}>
      <ToggleMore allVisibleItems={EServices.length}>
        {({ visible, toggleMore }) => (
          <div className="e-services">
            <Modal>
              <List
                items={EServices}
                matomoTrackingClass={matomoTrackingClass}
                modifiers={{
                  'card-link-list--is-collapsible': true,
                  'card-link-list--is-open': visible,
                }}
                itemChildren={(child) => {
                  const modal = child.Description && (
                    <div
                      key={child.ExternalId}
                      className="e-services__modal-container"
                    >
                      <OpenModalButton
                        open={child.ExternalId}
                        id={child.ExternalId}
                        className={'e-services__modal-open'}
                        ariaLabel={`${Translations.moreinformationabout} ${child.Text}`}
                        clickCallback={() => {
                          setTimeout(() => {
                            setFocus(child.ExternalId);
                          }, 0);
                        }}
                      >
                        <span />
                      </OpenModalButton>
                      <ModalPanel whenActive={child.ExternalId}>
                        <div
                          className={classNames({
                            'e-services__modal-panel': true,
                            'e-services__modal-panel--small':
                              !child.Description,
                          })}
                        >
                          <CloseModalButton
                            id={`${child.ExternalId}--close`}
                            className={'e-services__modal-close'}
                          >
                            <span className="show-for-sr">
                              {Translations.close}
                            </span>
                          </CloseModalButton>
                          <div
                            className="e-services__modal-panel__content"
                            tabIndex="0"
                            role="group"
                            aria-labelledby={child.Text}
                          >
                            <Fragment>
                              <span className="e-services__modal-panel__conditions">
                                {child.Heading}
                              </span>
                              <h4 id={child.Text}>{child.Text}</h4>
                              <div
                                className="e-services__modal-panel__description"
                                dangerouslySetInnerHTML={{
                                  __html: child.Description,
                                }}
                              />
                            </Fragment>
                          </div>
                        </div>
                      </ModalPanel>
                    </div>
                  );

                  return [
                    modal,
                    <span key={`tab${child.ExternalId}`} tabIndex="-1" />,
                  ];
                }}
              />
            </Modal>

            <div
              className={classNames({
                'e-services__togglebtn-container': true,
                'e-services__togglebtn-container--is-gt-4':
                  EServices.length > 4,
                'e-services__togglebtn-container--is-gt-10':
                  EServices.length > 10,
              })}
            >
              <button
                className="e-services__toggle-button"
                type="button"
                onClick={() => toggleMore(expandableList.current)}
              >
                <i
                  className={classNames({
                    'e-services__toggle-icon': true,
                    'e-services__toggle-icon--is-open': visible,
                  })}
                />
                <span>
                  {visible
                    ? `${Translations.showless}`
                    : `${Translations.showmore}`}
                </span>
              </button>
            </div>
          </div>
        )}
      </ToggleMore>
    </div>
  );
};

export default EServices;
